import React, { useState, useEffect, useRef } from 'react';
import { StyleSheet, Text, Pressable, View, Image } from 'react-native';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';

const COUNTRIES = [
    { code: 'us', label: 'United States', flag: 'https://flagcdn.com/w320/us.png' },
    { code: 'ca', label: 'Canada', flag: 'https://flagcdn.com/w320/ca.png' },
];

const LanguageSelector = () => {
    const [selected, setSelected] = useState(COUNTRIES[0]);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !(dropdownRef.current as any).contains(event.target)) {
                setDropdownVisible(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <View style={styles.container} ref={dropdownRef}>
            <Pressable
                style={({ pressed }) => [styles.flagButton, pressed && { opacity: 0.85 }]}
                onPress={() => setDropdownVisible(!dropdownVisible)}
            >
                <View style={styles.flagImageWrap}>
                    <Image source={{ uri: selected.flag }} style={styles.flagImage} />
                </View>
            </Pressable>

            {dropdownVisible && (
                <View style={styles.dropdown}>
                    {COUNTRIES.map((item) => {
                        const isSelected = item.code === selected.code;
                        return (
                            <Pressable
                                key={item.code}
                                style={({ pressed }) => [
                                    styles.dropdownItem,
                                    isSelected && styles.dropdownItemSelected,
                                    pressed && { backgroundColor: '#F1F5F9' },
                                ]}
                                onPress={() => {
                                    setSelected(item);
                                    setDropdownVisible(false);
                                }}
                            >
                                <View style={styles.dropdownFlagWrap}>
                                    <Image source={{ uri: item.flag }} style={styles.dropdownFlag} />
                                </View>
                                <Text style={[styles.dropdownLabel, isSelected && styles.dropdownLabelSelected]}>
                                    {item.label}
                                </Text>
                                {isSelected && (
                                    <MaterialCommunityIcons name="check" size={16} color="#1D4ED8" style={{ marginLeft: 'auto' }} />
                                )}
                            </Pressable>
                        );
                    })}
                </View>
            )}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        marginTop: 3,
        marginRight: 12,
        zIndex: 10,
    },
    flagButton: {
        width: 44,
        height: 44,
        borderRadius: 22,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#FFFFFF',
        borderWidth: 1,
        borderColor: '#E5E7EB',
        shadowColor: '#000',
        shadowOpacity: 0.06,
        shadowRadius: 10,
        shadowOffset: { width: 0, height: 4 },
        elevation: 3,
        overflow: 'hidden',
    },
    flagImageWrap: {
        width: 28,
        height: 28,
        borderRadius: 14,
        overflow: 'hidden',
    },
    flagImage: {
        width: '100%',
        height: '100%',
    },
    dropdown: {
        position: 'absolute',
        top: 50,
        right: 0,
        backgroundColor: '#FFFFFF',
        borderWidth: 1,
        borderColor: 'rgba(0,0,0,0.06)',
        borderRadius: 14,
        width: 200,
        shadowColor: '#000',
        shadowOpacity: 0.1,
        shadowRadius: 18,
        shadowOffset: { width: 0, height: 10 },
        elevation: 6,
        paddingVertical: 6,
    },
    dropdownItem: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        paddingHorizontal: 14,
        paddingVertical: 11,
        borderRadius: 8,
        marginHorizontal: 4,
    },
    dropdownItemSelected: {
        backgroundColor: '#EFF6FF',
    },
    dropdownFlagWrap: {
        width: 28,
        height: 20,
        borderRadius: 4,
        overflow: 'hidden',
    },
    dropdownFlag: {
        width: '100%',
        height: '100%',
    },
    dropdownLabel: {
        fontSize: 14,
        fontWeight: '400',
        color: '#374151',
    },
    dropdownLabelSelected: {
        fontWeight: '600',
        color: '#1D4ED8',
    },
});

export default LanguageSelector;
